'use client';

import React, { useState } from 'react';
import { Tabs, Tab, Box, Tooltip, IconButton, CircularProgress, Typography } from '@mui/material';
import POVendorTreeMap from '../../components/POSummary/POVendorTreeMap';
import POVendorGrid from '../../components/POSummary/POVendorGrid';
import PirateAudits from '../../components/POSummary/PirateAudits';
import PaymentAnalysis from '../../components/POSummary/PaymentAnalysis';
import useFetchPOSummary from '../../hooks/useFetchPOSummary';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

function POSummary() {
  const [tabIndex, setTabIndex] = useState(0);
  const { purchaseOrders, loading, error } = useFetchPOSummary();
  const [loadedComponents, setLoadedComponents] = useState({});
  const [allLoaded, setAllLoaded] = useState(false);

  const expectedComponents = ['treeMap', 'grid', 'payment', 'audit'];

  const setChildLoaded = (key) => {
    setLoadedComponents((prev) => {
      const updated = { ...prev, [key]: true };
      const isAllLoaded = expectedComponents.every((comp) => updated[comp]);
      if (isAllLoaded) setAllLoaded(true);
      return updated;
    });
  };

  const handleChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };

  const videoUrl = 'https://wwmstaticwebdeploy.blob.core.windows.net/tutorials/adminTest.mp4';

  return (
    <Box sx={{ width: '100%', padding: '20px', position: 'relative' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
        }}
      >
        <Tabs
          value={tabIndex}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            '& .MuiTab-root': {
              minWidth: '180px',
              fontSize: '16px',
              padding: '12px 20px',
              textTransform: 'none',
            },
            '& .MuiTabs-indicator': {
              height: '4px',
              borderRadius: '2px',
            },
          }}
        >
          <Tab label="Overview" />
          <Tab label="Procurement Payment Process Analysis" />
          <Tab label="Pirate Audits" />
        </Tabs>

        {/* <Tooltip title="Watch Tutorial">
          <IconButton
            onClick={() => window.open(`/tutorial?videoUrl=${encodeURIComponent(videoUrl)}`, '_blank')}
            color="primary"
          >
            {' '}
            <HelpOutlineIcon />
          </IconButton>
        </Tooltip> */}
      </Box>

      {!allLoaded && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 2000,
            width: '100vw',
            height: '100vh',
            bgcolor: 'rgba(255, 255, 255, 0.5)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="h6" sx={{ mb: 2, color: 'text.secondary' }}>
            Loading PO Summary, Please Standby
          </Typography>
          <CircularProgress size={60} thickness={5} />
        </Box>
      )}

      <Box sx={{ visibility: allLoaded ? 'visible' : 'hidden' }}>
        <Box hidden={tabIndex !== 0}>
          <POVendorTreeMap
            purchaseOrders={purchaseOrders}
            loading={loading}
            error={error}
            onLoaded={() => setChildLoaded('treeMap')}
          />
          <POVendorGrid
            purchaseOrders={purchaseOrders}
            loading={loading}
            error={error}
            onLoaded={() => setChildLoaded('grid')}
          />
        </Box>

        <Box hidden={tabIndex !== 1}>
          <PaymentAnalysis onLoaded={() => setChildLoaded('payment')} />
        </Box>

        <Box hidden={tabIndex !== 2}>
          <PirateAudits onLoaded={() => setChildLoaded('audit')} />
        </Box>
      </Box>
    </Box>
  );
}

export default POSummary;
